export default __webpack_public_path__ + "static/media/hotelBook1.5b034486.jpg";